import React, { useEffect } from "react";
import { useAppDispatch, useAppSelector } from "../../../../../../Redux/hooks";
import { loadConsentDetails } from "../../../../../../Redux/actions/providerConsentAction";
import ConsentBlockWrapper from "./ConsentBlockWrapper";
import { Backdrop, Typography } from "@mui/material";
import { resetConsentState } from "../../../../../../Redux/reducers/providerConsentSlice";
import {
  CBArea,
  CBMessageWrapper,
} from "../../../../../EConsent/Builder/block.style";
import ConsentFormEmpty from "./ConsentFormEmpty";
import ConsentFormHeader from "./ConsentFormHeader";
import Loader from "../../../../../Common/assets/Loader";

type Props = {
  studyId?: string;
  participantId: string;
  consentId: string;
  formId: string;
  type: "platform" | "study";
};

const ConsentForm: React.FC<Props> = ({
  studyId,
  participantId,
  consentId,
  formId,
  type,
}) => {
  const dispatch = useAppDispatch();

  const loading = useAppSelector((state) => state.providerConsent.loading);
  const error = useAppSelector((state) => state.providerConsent.error);
  const blocks = useAppSelector((state) => state.providerConsent.blocks);

  useEffect(() => {
    if (formId && type)
      dispatch(
        loadConsentDetails(studyId, participantId, consentId, formId, type)
      );
    return () => {
      dispatch(resetConsentState());
    };
  }, [dispatch, studyId, formId, participantId, consentId, type]);

  return (
    <div className="preview-wrapper">
      {loading && (
        <Backdrop
          open={true}
          sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        >
          <Loader />
        </Backdrop>
      )}
      <ConsentFormHeader />
      {error ? (
        <CBMessageWrapper>
          <Typography variant="h3" color="grey">
            {error}
          </Typography>
        </CBMessageWrapper>
      ) : (
        <CBArea style={{ padding: "0px" }}>
          {loading ? null : blocks.length === 0 ? (
            <ConsentFormEmpty />
          ) : (
            <ConsentBlockWrapper />
          )}
        </CBArea>
      )}
    </div>
  );
};

export default ConsentForm;
